import { render, staticRenderFns } from "./liBatteryIndex.vue?vue&type=template&id=71d49a51"
import script from "./liBatteryIndex.vue?vue&type=script&lang=js"
export * from "./liBatteryIndex.vue?vue&type=script&lang=js"
import style0 from "./liBatteryIndex.vue?vue&type=style&index=0&id=71d49a51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports